export const frostEn = {
  frost: {
    title: "Frost Protection",
    subtitle: "Advanced frost prediction system with SMS alerts and protection recommendations",
    selectParcel: "Select a Parcel",
    selectParcelDesc: "Choose a parcel to view frost predictions",
    selectParcelPlaceholder: "Select a parcel",
    noPredictions: "Select a parcel to view frost predictions",
    premiumMonitor: "Premium Frost Monitor",
    prediction48h: "48-72h prediction with real meteorological data",
    updatePrediction: "Update Prediction",
    updating: "Updating...",
    generating: "Generating...",
    generatePredictions: "Generate Predictions",
    noPredictionsYet: "No frost predictions available yet",
    predictions72h: "72h Predictions",
    inHours: "In {{hours}} hours",
    frostAlert: "FROST ALERT!",
    highRiskPredictions: "{{count}} high-risk predictions in the next {{hours}} hours",
    riskLevels: {
      none: "None",
      low: "Low",
      moderate: "Moderate",
      high: "High",
      extreme: "Extreme"
    },
    metrics: {
      temperature: "Temperature",
      probability: "Probability",
      wind: "Wind",
      humidity: "Humidity",
      clouds: "Clouds"
    },
    terrain: {
      title: "Terrain & Frost Drainage Analysis",
      subtitle: "NASADEM elevation data for cold air drainage risk assessment",
      elevation: "Elevation",
      aboveSeaLevel: "Above sea level",
      slope: "Slope",
      terrainGradient: "Terrain gradient",
      aspect: "Aspect",
      slopeDirection: "Slope direction",
      frostPocketRisk: "Frost Pocket Risk",
      coldAirPooling: "Cold air pooling",
      coldAirDrainage: "Cold Air Drainage Assessment",
      elevatedRisk: "Based on terrain analysis, this parcel is at elevated risk of cold air pooling during clear, calm nights. Consider active frost protection measures.",
      lowRisk: "Based on terrain analysis, this parcel has moderate to low cold air drainage risk. Standard monitoring recommended.",
      dataSource: "Data source: NASADEM (30m resolution) via CREODIAS. Elevation affects radiative cooling and cold air drainage patterns."
    },
    thresholds: {
      title: "Crop Frost Damage Thresholds",
      subtitle: "Reference temperatures at which frost damage occurs by crop and growth stage",
      crop: "Crop",
      criticalTemp: "Critical Temp (Tc)",
      growthStage: "Growth Stage",
      notes: "Notes",
      tip: "Use the Critical Temperature (Tc) for your crop as the Frost Threshold below. Set a slightly higher value (e.g., +1°C) for earlier warning.",
      scientificRefs: "Scientific References"
    },
    alertConfig: {
      title: "Alert Configuration",
      subtitle: "Customize how and when to receive frost alerts",
      enableSms: "SMS Alerts",
      enableEmail: "Email Alerts",
      phoneNumber: "Phone Number",
      threshold: "Temperature Threshold (°C)",
      advanceNotice: "Advance Notice (hours)",
      saveConfig: "Save Configuration",
      saving: "Saving...",
      configSaved: "Configuration Saved",
      configSavedDesc: "Frost alerts configured successfully"
    },
    recommendedActions: "Recommended actions:",
    dataSource: "Data:"
  },
  climateReport: {
    title: "Climate Event Report",
    subtitle: "Informe de Evento Climático",
    generateReport: "Generate Event Report",
    generating: "Generating...",
    eventSummary: "Event Summary",
    eventType: "Event Type",
    frost: "Frost",
    dateRange: "Date Range",
    maxProbability: "Max Probability",
    riskLevel: "Risk Level",
    parcelInfo: "Parcel Information",
    parcelName: "Name",
    crop: "Crop",
    location: "Location",
    area: "Area",
    frostExposure: "Frost Exposure",
    meteorologicalData: "Meteorological Data",
    dataSource: "Data Source",
    model: "Model",
    factors: "Factors",
    date: "Date",
    minTemp: "Min Temp",
    probability: "Probability",
    impactAssessment: "Impact Assessment",
    affectedArea: "Estimated affected area",
    damagePotential: "Crop damage potential",
    criticalThreshold: "Critical temperature threshold",
    certification: "Certification & Disclaimer",
    reportId: "Report ID",
    generatedAt: "Generated At",
    modelConfidence: "Model Confidence",
    disclaimer: "This report is generated based on predictive models using meteorological data from Open-Meteo and AEMET. It does not replace professional assessment by agronomists or insurance adjusters. Sentinel Crop provides this analysis for informational purposes only.",
    downloadPdf: "Download PDF Report",
    noFrostEvents: "No significant frost events detected",
    noFrostEventsDesc: "There are no HIGH or EXTREME risk frost predictions for this parcel. Generate a report when frost events occur."
  }
};
